import { http } from 'lib/services/http';
import { http as restHttp } from 'api/taxIdService';
import { platformAdminBaseUrl } from 'constants/apiUrls';

const COMPANY_API_PATH = `${platformAdminBaseUrl}/company`;

export const getCompanyInfo = (authV3Enabled: boolean) => {
  return authV3Enabled
    ? restHttp.get('/company')
    : http.get(`${COMPANY_API_PATH}/retrieve`);
};

export const updateCompanyInfo = (payload) => {
  return http.put(`${COMPANY_API_PATH}`, payload);
};
